import React, { useState, useEffect } from 'react';
import EventService from '../../utils/EventService';
import * as CookieConsentConstants from '../CookieConsentManager/CookieConsentConstants';
import { Helmet } from 'react-helmet';
export interface IAnalyticsProps {
  id: string;
}

//remove the scripts immediately when changing the settings from specific domain (gtm.socialstyrelsen.se) in this case.
const removeScriptTagsWithSrc = (domain) => {
  const head = document.head || document.querySelector('head');

  if (!head) {
    return;
  }

  const scripts = Array.from(head.getElementsByTagName('script'));

  scripts
    .filter((script) => {
      const src = script.getAttribute('src');
      return src && src.includes(domain);
    })
    .forEach((script) => {
      if (script.parentNode) {
        script.parentNode.removeChild(script);
      }
    });
};

export const Analytics = (props: IAnalyticsProps) => {
  const [insertTagmanager, setTagmanager] = useState(false);
  useEffect(
    () => {
      const onConsentsStatistics = () => {
        setTagmanager(true);
      };

      const onDenyStatistics = () => {
        setTagmanager(false);
        removeScriptTagsWithSrc('gtm.socialstyrelsen.se');
      };

      EventService.subscribe(CookieConsentConstants.statisticsConsentEvent, onConsentsStatistics);

      EventService.subscribe(CookieConsentConstants.statisticsConsentDenyEvent, onDenyStatistics);
      // cleanup this component
      return () => {};
    },
    [] /*only run when the component first renders.*/
  );

  return (
    insertTagmanager && (
      <Helmet>
        <script>
          {`(function (w, d, s, l, i) {
    w[l] = w[l] || [];
    w[l].push({
      'gtm.start': new Date().getTime(),
      event: 'gtm.js',
    });
    var f = d.getElementsByTagName(s)[0],
      j = d.createElement(s),
      dl = l != 'dataLayer' ? '&l=' + l : '';
    j.async = true;
    j.src = 'https://gtm.socialstyrelsen.se/gtm.js?id=' + i + dl;
    f.parentNode.insertBefore(j, f);
  })(window, document, 'script', 'dataLayer', '${props.id}');`}
        </script>
      </Helmet>
    )
  );
};
